import React from "react";
import { Box, Typography } from "@mui/material";

interface FormSectionProps {
  id: string;
  questionNumber: number;
  question: string;
  children: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({
  id,
  questionNumber,
  question,
  children,
}) => {
  return (
    <Box id={id} sx={{ mb: 4 }}>
      <Typography
        variant="subtitle1"
        component="h3"
        sx={{ fontWeight: 500, color: "text.secondary", mb: 2 }}
      >
        {questionNumber}. {question}
      </Typography>
      {children}
    </Box>
  );
};
